import { FC, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BreadcrumbContainer, PageContainer, Upper } from "../LandingPage/LandingPage";
import { Tabs, Tab, Typography, Box } from "@mui/material";
import AppBreadcrumb from "../../components/AppBreadcrumb";
import styled from "@emotion/styled";
import OverviewTab from "./tabs/OverviewTab";
import UserMetricsTab from "./tabs/UserMetricsTab";
import TrialAnalyticsTab from "./tabs/TrialAnalyticsTab";
import SiteMetricsTab from "./tabs/SiteMetricsTab";
import FeatureUsageTab from "./tabs/FeatureUsageTab";

const tabConfig = [
    { key: "overview", label: "Overview", text: "OVERVIEW", component: <OverviewTab /> },
    { key: "user-metrics", label: "User Metrics", text: "USER METRICS", component: <UserMetricsTab /> },
    { key: "trial-analytics", label: "Trial Analytics", text: "TRIAL ANALYTICS", component: <TrialAnalyticsTab /> },
    { key: "site-metrics", label: "Site Metrics", text: "SITE METRICS", component: <SiteMetricsTab /> },
    { key: "feature-usage", label: "Feature Usage", text: "FEATURE USAGE", component: <FeatureUsageTab /> },
];

const AdminAnalytics: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.split("/").pop() || "overview";

    useEffect(() => {
        if (location.pathname === "/admin-analytics") {
            navigate("/admin-analytics/overview", { replace: true });
        }
    }, [location.pathname, navigate]);

    const activeTab = useMemo(
        () => tabConfig.find((tab) => tab.key === path) ?? tabConfig[0],
        [path]
    );

    return (
        <PageContainer>
            <BreadcrumbContainer>
                <AppBreadcrumb
                    links={[
                        { href: "/", text: "" },
                        { href: "/admin-analytics", text: "ADMIN ANALYTICS" },
                        { href: `/admin-analytics/${activeTab.key}`, text: activeTab.text },
                    ]}
                />
            </BreadcrumbContainer>
            <Upper>
                <Typography variant="h2">Admin Analytics</Typography>
                <Typography variant="body1" color="#4b5563" sx={{ mb: 2 }}>
                    Track user metrics and make data-driven decisions
                </Typography>
            </Upper>
            <StyledTabs
                value={activeTab.key}
                onChange={(_, newValue) => navigate(`/admin-analytics/${newValue}`)}
                TabIndicatorProps={{ style: { backgroundColor: "#D31710", height: "2px", borderRadius: "50px" }, }}
                variant="scrollable"
                scrollButtons={false}
            >
                {tabConfig.map((tab) => (<Tab key={tab.key} label={tab.label} value={tab.key} />))}
            </StyledTabs>
            <Box sx={{ mt: 3 }}>{activeTab.component}</Box>
        </PageContainer>
    );
};

const StyledTabs = styled(Tabs)`
  border-bottom: 2px solid #e5e7eb;
  max-width: 100%;
  .MuiTab-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-transform: none;
    color: #4b5563;
  }
  .Mui-selected {
    color: #D31710 !important;
    font-weight: 600;
  }
`;

export default AdminAnalytics;